import * as store from '@attain-apps/fe/web/main/lib/store'

import type { Api } from '../api'
import type { Collection } from '../collection'

import { getActionsConfig } from './actions'
import * as effects from './effects'
import { Selectors } from './selectors'
import { State } from './state'

/** Child feature owning concurrent execution state for a connector collection. */
export class Feature extends store.Feature<
  State,
  Selectors,
  ReturnType<typeof getActionsConfig>
> {
  constructor(collection: Collection, api: Api) {
    super({
      actions: getActionsConfig(),
      initialState: State.INITIAL,
      name: 'IntegrationConnectorRuns',
      parent: collection.feature,
      selectors: () => new Selectors(this),
    })
    this.registerEffects(
      effects.executeRun(collection, api),
      effects.subscribeRunProgress(collection, api),
    )
  }
}
